import { Outlet } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import Header from '../header';
import PortalLogo from '../../assets/logo-portal.svg';
import { selectActiveFormInvestigationType, resetState } from '../../reducers/active-form-slice';
import { selectActiveFeatures, selectPortalUser } from "../../reducers/auth-slice";
import { resetAdditionalInformationFiles } from '../../reducers/additional-information-files-slice';
import { resetSWITRSDetailsFiles } from '../../reducers/switrs-details-files-slice';
import { resetTrafficCollisionsReportRetrievalFiles } from '../../reducers/traffic-collisions-report-retrieval-files-slice';
import { resetFaultInfoFilesStatus } from '../../reducers/fault-info-files-slice';
import { resetAttachmentsAfterSubmission } from "../../reducers/attachments-slice";
import AccessDeniedMessageModal from "../modals/access-denied-message";
import ConfirmCancelModal from "../modals/confirm-cancel-order";
import { useMsal } from '@azure/msal-react';

/// need to logout or redirect to home if status is not Enabled

const LayoutIntake = () => {
    let location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const investigationType = useSelector(selectActiveFormInvestigationType);
    const portalUser = useSelector(selectPortalUser);
    const activeFeatures = useSelector(selectActiveFeatures);
    const [accessDenied, setAccessDenied] = useState(false)
    const { instance } = useMsal();

    useEffect(() => {
        setAccessDenied(portalUser.organization && portalUser.organization.status !== 'Enabled')
    }, [portalUser, activeFeatures]);

    const handleHideModal = () => {
        let activeAccount = instance.getActiveAccount();
        if (activeAccount) {
            instance.logout(activeAccount)
        }
    }
    
    const [showConfirmCancelModal, setShowConfirmCancelModal] = useState(false);
    const toggleConfirmCancelModal = () => {
        setShowConfirmCancelModal(!showConfirmCancelModal);
    }

    const handleResetFormValues = async () => {
        await dispatch(resetState());
        await dispatch(resetSWITRSDetailsFiles());
        await dispatch(resetAdditionalInformationFiles());
        await dispatch(resetTrafficCollisionsReportRetrievalFiles());
        await dispatch(resetFaultInfoFilesStatus());
        await dispatch(resetAttachmentsAfterSubmission());
    }; 


    /**
     * handle the next button
     */
    const handleNext = async () => {
        await handleResetFormValues();
        navigate("/portal");
    };

    return (
        <div className='layout intake'>
            <div className="left-rail">
                <a href="#" onClick={toggleConfirmCancelModal}><img className="logo" src={PortalLogo} alt='portal' /></a>
            </div>

            <div className='layout-content'>
                <Header showUserName={true} />

                <div className='layout-content-outlet'>
                    <h1>{(location.pathname === "/intake" || location.pathname === "/intake/") ? '' : investigationType[0]}</h1>
                    <AccessDeniedMessageModal showModal={accessDenied} handleHideModal={handleHideModal} message={"Please contact Glucroft Investigations Office at 866-411-8646 regarding your account.  Thank you."} />
                    <Outlet />
                    <div className="layout-content-support">
                        <span>For any issues, please contact Glucroft Support at <a href="mailto:glucroftsupport@fuel.digital">glucroftsupport@fuel.digital</a></span>
                    </div>
                </div>
            </div>

            <ConfirmCancelModal
                showConfirmCancelModal={showConfirmCancelModal}
                handleHideConfirmCancelModal={toggleConfirmCancelModal}
                handleShowSubmissionFailureModal={handleNext}
                handleResetFormValues={handleNext}
            />
        </div>
    );
}

export default LayoutIntake;